/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { loadPrinterGroup } from '@/model/dataLayer/api/print/printerCommonApi'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false
  },
  name: {
    displayName: 'PrintGroup'
  },
  isSingleLinePrint: {
    type: IKDataEntity.Types.Boolean,
    displayName: 'isSingleLinePrint'
  },
  isSingleOrderPrint: {
    type: IKDataEntity.Types.Boolean,
    displayName: 'isSingleOrderPrint'
  },
  upsideDown: {
    type: IKDataEntity.Types.Boolean
  },
  printerCount: {
    displayName: 'PrintDeviceCount',
    formConfig: {
      inEdit: false,
      inNew: false
    }
  },
  defaultRetryCount: {
    formConfig: {
      default: '0'
    }
  },
  totalDishesCount: {
    formConfig: {
      inEdit: false,
      inNew: false
    }
  }
}
const config = {
  load: loadPrinterGroup,
  add: async function (item) {
    return (await hillo.postWithUploadFile('Printer.php?op=addPrinterGroups', item, {
      showLoading: true
    })).content
  },
  edit: function (item, showLoading = true) {
    return hillo.postWithUploadFile('Printer.php?op=updatePrinterGroups', item, {
      showLoading
    })
  },
  remove: function (id) {
    return hillo.post('Printer.php?op=deletePrinterGroup', { id })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
